export class Popup {
    showComparePopup: boolean;
    showPromotionPopup: boolean;
    constructor() {
        this.showComparePopup = false;
        this.showPromotionPopup = false;
    }
}
